import React, { FC } from "react";
import styles from "./HorizontalInfoList.module.scss";

type Props = {
  list: Array<{
    label: string;
    text: string;
  }>;
};

const HorizontalInfoList: FC<Props> = ({ list }: Props) => {
  const formattedList = (list || []).filter(item => !!item.text);

  return (
    <div className={styles.list}>
      {formattedList.map((item, i) => (
        <div className={styles.listItem} key={i}>
          <span className={styles.listItemLabel}>{item.label}</span>
          <span className={styles.listItemValue}>{item.text}</span>
        </div>
      ))}
    </div>
  );
};

export default HorizontalInfoList;
